import React  from 'react';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import { createTheme, ThemeProvider } from '@mui/material/styles';


const theme = createTheme();

const useStyles = makeStyles((theme) => ({
    footer:{
      color:'white'
    }
  }));

export default function Copyright() {
    const classes = useStyles();
    return <ThemeProvider theme={theme}>
      <Typography variant="body2" align="center" sx={{ color: 'white' }}>
        {'Copyright © '}
        <Link color="inherit" href="https://claveunica.uss.cl/" className={classes.footer}>
          Clave Unica
        </Link>{' '}
        -
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    </ThemeProvider>;

  }